import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import {IOilFilter, IState, IVehicle, Replacement} from '../../../../interface';
import style from './index.module.scss';
import localesReplacement from '../../../../utils/localesReplacement';
import {useNavigate} from 'react-router-dom';

const cx = classnames.bind(style);

interface Props extends IOilFilter {
  vehicle: IVehicle | undefined;
  replacements: Replacement;
  setVehicle: (value: IVehicle | undefined) => void;
  disabled: boolean;
  clickHandler: () => void;
}

//Vehicle dropdown component
export const VehicleSelection = (props: Props) => {
  const {replacements, vehicle, setVehicle, disabled, clickHandler} = props;
  const navigate = useNavigate();
  const remove = (evt: React.MouseEvent) => {
    setVehicle(undefined);
    evt.stopPropagation();
  };
  const redirectHandle = (evt: React.MouseEvent) => {
    navigate('/');
    evt.stopPropagation();
  };
  const noVehicle =
    _.isUndefined(vehicle) ||
    _.chain(vehicle).values().compact().isEmpty().value();
  return (
    <div
      className={cx('vehicle-selection', 'selected', {
        disabled: disabled,
        hasValue: !noVehicle,
      })}
      onClick={clickHandler}
    >
      <div className={cx('dropdown')}>
        {noVehicle ? (
          <>
            <strong>{localesReplacement(replacements, 'Vehicle')}</strong>
            <div className={cx('input-with-close')}>
              <span className={`overflowText ${cx('selected')}`}>
                {localesReplacement(replacements, 'Find your vehicle')}
              </span>
            </div>
          </>
        ) : (
          <>
            <strong>{`${vehicle['make']}  ${vehicle['model']}`}</strong>
            <div className={cx('input-with-close')}>
              <span className={`overflowText ${cx('selected')}`}>
                {`${vehicle['type']} (${vehicle['yearFrom']} - ${vehicle['yearTo']})`}
              </span>
              {!_.chain(vehicle).values().compact().isEmpty().value() && (
                <span
                  className={`button ${cx('remove-button')}`}
                  onClick={remove}
                  role='button'
                ></span>
              )}
            </div>
          </>
        )}
      </div>
      <span role='link' className={cx('link')} onClick={redirectHandle}>
        {localesReplacement(replacements, 'Start Over')}
      </span>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  vehicle: state.filter.vehicle,
});

export default connect(mapStateToProps)(VehicleSelection);
